import React from "react";
import styles from "./TermsCondition.module.css";

export default function TermsCondition() {
  return (
    <div className={styles.container}>
      <div>
        <h1>Terms and Conditions</h1>

        <p>
          By using this website and purchasing our software products, you agree
          to the following Terms and Conditions. Please read them carefully.
        </p>

        <h2>1. Scope</h2>
        <p>
          These Terms apply to all users of RisingDSP software products, including
          plugins, presets, and license services.
        </p>

        <h2>2. License Grant</h2>
        <p>
          Each purchased license grants the user the right to install and use the
          software on up to <strong>three (3) computers</strong>.
          <br /><br />
          Additional licenses can be purchased to increase the number of
          authorized devices.
        </p>

        <h2>3. License Management</h2>
        <p>
          Licenses are managed via the licensing system (Moonbase). The system
          tracks activations to ensure fair usage.
        </p>

        <h2>4. User Content (Presets)</h2>
        <p>
          Users are allowed to create, use, sell, and distribute their own
          presets generated with the software.
          <br /><br />
          Presets remain the intellectual property of the user.
        </p>

        <h2>5. Marketplace Usage</h2>
        <p>
          Users may sell or gift their own presets to other users. RisingDSP is
          not responsible for user-to-user transactions or content quality.
        </p>

        <h2>6. Restrictions</h2>
        <p>
          You may not:
          <br />• Reverse engineer or decompile the software
          <br />• Share or resell license keys
          <br />• Circumvent license activation systems
        </p>

        <h2>7. Payments</h2>
        <p>
          Payments are processed securely via Stripe. Credit card informations are not stored.
        </p>

        <h2>8. Refund Policy</h2>
        <p>
          Refunds are generally not provided for digital products once the license
          has been activated, unless required by law.
        </p>

        <h2>9. Liability</h2>
        <p>
          RisingDSP is not liable for any direct or indirect damages resulting from the
          use of the software. Use at your own risk.
        </p>

        <h2>10. Changes</h2>
        <p>
          RisingDSP reserve the right to update these Terms at any time. Continued use of
          the service constitutes acceptance of the updated Terms.
        </p>

        <h2>11. Contact</h2>
        <p>
          For questions regarding these Terms, contact:
          <br />
          info@risingdsp.com
        </p>
      </div>
    </div>
  );
}